type AnalyticsEventName =
  | "newsletter_signup"
  | "test"
interface AnalyticsEventPayload {
  [key: string]: unknown;
}

interface AnalyticsEvent {
  name: AnalyticsEventName;
  payload: AnalyticsEventPayload;
}

interface AnalyticsContext {
  userId: string | null | undefined;
  companyId: string | null | undefined;
}

declare global {
  interface Window {
    dataLayer?: Array<Record<string, unknown>>;
    gtag?: (...args: unknown[]) => void;
  }
}

export class AnalyticsService {
  public context: AnalyticsContext = { userId: undefined, companyId: undefined };
  private queue: AnalyticsEvent[] = [];
  private dataLayer: Array<Record<string, unknown>>;

  constructor() {
    this.dataLayer = window.dataLayer || [];
  }

  public track(eventName: AnalyticsEventName, payload: AnalyticsEventPayload = {}): void {
    const event: AnalyticsEvent = { name: eventName, payload };
    this.pushToDataLayer(event);
  }

  public flushQueue(): void {
    while (this.queue.length > 0) {
      const event = this.queue.shift();
      if (event) {
        this.pushToDataLayer(event);
      }
    }
  }

  private pushToDataLayer(event: AnalyticsEvent): void {
    const dataLayerEvent = {
      event: event.name,
      ...event.payload,
    };

    this.dataLayer.push(dataLayerEvent);
  }
}